<template>
    <el-drawer append-to-body :visible.sync="drawerVisible" :with-header="false" direction="rtl" size="680px">
        <div v-if="drawerVisible" class="container">
            <!-- 原订单信息 -->
            <div class="card">
                <RoomTypeList :order-detail-list="orderDetailList"/>
            </div>

            <!-- 切换 Tab -->
            <div class="tab-bar">
                <div :class="{ active: activeTab === 'cancel' }" class="tab-item" @click="activeTab = 'cancel'">减少数量</div>
                <div :class="{ active: activeTab === 'add' }" class="tab-item" @click="activeTab = 'add'">增加数量</div>
            </div>

            <!-- 减少数量（取消） -->
            <div v-show="activeTab === 'cancel'" class="card">
                <div class="section-title">减少数量（取消）</div>
                <div v-for="(item, idx) in cancelList" :key="idx" class="edit-row">
                    <el-select v-model="item.roomId" placeholder="选择房型" size="medium" style="width:200px" @change="(val) => onCancelRoomChange(val, idx)">
                        <el-option v-for="opt in cancelRoomOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
                    </el-select>
                    <el-select v-model="item.date" placeholder="请先选房型" size="medium" style="width:220px"
                               :disabled="!item.roomId" @change="(val) => onCancelDateChange(val, idx)">
                        <el-option v-for="d in item.availableDates || []" :key="d" :label="d" :value="d"></el-option>
                    </el-select>
                    <div class="qty-wrap">
                        <el-input v-model.number="item.quantity" :disabled="!item.roomId || item.loadingQty"
                                 size="medium" style="width:120px" type="number" placeholder="请输入" @input="onCancelQtyInput(idx)"></el-input>
                        <span v-if="!item.loadingQty" class="qty-hint">{{ getCancelQtyHint(idx) }}</span>
                        <span v-if="item.loadingQty" class="qty-hint loading">查询中...</span>
                    </div>
                    <i v-if="cancelList.length > 1" class="el-icon-close delete-btn" @click="removeCancelItem(idx)"></i>
                </div>
                <div class="add-item-btn" @click="addCancelItem"><i class="el-icon-plus"></i> 添加取消项</div>
                <div class="submit-row">
                    <el-button type="primary" class="submit-btn btn-red" @click="confirmCancel">确认取消</el-button>
                </div>
            </div>

            <!-- 增加数量（询价） -->
            <div v-show="activeTab === 'add'" class="card">
                <div class="section-title">增加数量（询价）</div>
                <div v-for="(item, idx) in addList" :key="idx" class="edit-row">
                    <el-select v-model="item.roomId" placeholder="选择房型" size="medium" style="width:200px" @change="(val) => onAddRoomChange(val, idx)">
                        <el-option v-for="opt in inquiryRoomOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
                    </el-select>
                    <el-date-picker v-model="item.date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                                    size="medium" style="width:220px" :picker-options="datePickerOptions" @change="(val) => onAddDateChange(val, idx)"></el-date-picker>
                    <el-input v-model.number="item.quantity" size="medium" style="width:120px" type="number"
                             placeholder="请输入" @input="onAddQtyInput(idx)"></el-input>
                    <i v-if="addList.length > 1" class="el-icon-close delete-btn" @click="removeAddItem(idx)"></i>
                </div>
                <div class="add-item-btn" @click="addAddItem"><i class="el-icon-plus"></i> 添加增订项</div>
                <div class="submit-row">
                    <el-button type="primary" class="submit-btn btn-dark" @click="confirmInquiry">立即询价</el-button>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import RoomTypeList from "./RoomTypeList.vue";
import Api from '@/components/Api/index'

export default {
    name: 'EditOrderPage',
    components: { RoomTypeList },
    data() {
        return {
            orderId: '',
            drawerVisible: false,
            activeTab: 'cancel',
            orderInfo: {},
            hotelInfo: {},
            orderDetailList: [],
            cancelList: [{
                roomLabel: '',
                roomId: '',
                date: '',
                quantity: null,
                childrenDetailId: '',
                stockId: '',
                availableDates: [],
                maxQuantity: 0,
                loadingQty: false,
                qtyHint: ''
            }],
            addList: [{ roomLabel: '', roomId: '', date: '', quantity: null }],
            datePickerOptions: {
                disabledDate(date) {
                    return date.getTime() < new Date(new Date().toDateString()).getTime()
                }
            }
        }
    },
    computed: {
        roomOptionsFromOrder() {
            if (!this.orderDetailList || !this.orderDetailList.length) return []
            const roomItems = this.orderDetailList.filter(n => n.productName !== '城市税')
            return roomItems.map(item => ({
                label: item.productName || item.productNameEn || '未知房型',
                value: item.stockId,
                childrenDetailId: item.id,
                stockId: item.stockId,
                startTime: item.startTime,
                endTime: item.endTime,
                maxQuantity: (item.number || 0) - (item.cancelNumber || 0)
            }))
        },
        cancelRoomOptions() {
            return this.roomOptionsFromOrder
        },
        inquiryRoomOptions() {
            return [
                { label: '单人间', value: 'single' },
                { label: '双人间', value: 'double' },
                { label: '三人间', value: 'triple' }
            ]
        }
    },
    watch: {
        orderId: {
            handler(val) {
                if (val) {
                    this.fetchOrderData()
                }
            },
            immediate: true
        }
    },
    methods: {
        // 打开抽屉
        open(orderId) {
            this.orderId = orderId
            this.drawerVisible = true
            // 重置状态
            this.activeTab = 'cancel'
            this.cancelList = [{
                roomLabel: '', roomId: '', date: '', quantity: null,
                childrenDetailId: '', stockId: '',
                availableDates: [], maxQuantity: 0,
                loadingQty: false, qtyHint: ''
            }]
            this.addList = [{ roomLabel: '', roomId: '', date: '', quantity: null }]
        },
        async fetchOrderData() {
            try {
                const res = await new Api('').seeOrderDetail(this.orderId)
                if (res.status === 200) {
                    const data = res.data
                    this.orderInfo = data.orderListResult
                    this.hotelInfo = data.resourceInfo
                    this.orderDetailList = data.orderListResult?.orderListDetailResultList || []
                } else {
                    this.$message.error(res.statusText || '获取订单失败')
                }
            } catch (e) {
                console.error('获取订单详情失败', e)
                this.$message.error('获取订单失败')
            }
        },

        // ========== 取消项操作 ==========

        generateDateRange(start, end) {
            if (!start || !end) return []
            const [sy, sm, sd] = start.split('.').map(Number)
            const [ey, em, ed] = end.split('.').map(Number)
            const startDate = new Date(sy, sm - 1, sd)
            const endDate = new Date(ey, em - 1, ed)
            const dates = []
            const cur = new Date(startDate)
            while (cur <= endDate) {
                const y = cur.getFullYear()
                const m = String(cur.getMonth() + 1).padStart(2, '0')
                const d = String(cur.getDate()).padStart(2, '0')
                dates.push(`${y}-${m}-${d}`)
                cur.setDate(cur.getDate() + 1)
            }
            return dates
        },

        addCancelItem() {
            this.cancelList.push({
                roomLabel: '', roomId: '', date: '', quantity: '',
                childrenDetailId: '', stockId: '',
                availableDates: [], maxQuantity: 0,
                loadingQty: false, qtyHint: ''
            })
        },

        removeCancelItem(idx) {
            this.cancelList.splice(idx, 1)
        },

        onCancelRoomChange(val, idx) {
            const opt = this.cancelRoomOptions.find(o => o.value === val)
            if (opt) {
                const row = this.cancelList[idx]
                row.roomId = opt.value
                row.roomLabel = opt.label
                row.childrenDetailId = opt.childrenDetailId
                row.stockId = opt.stockId
                row.availableDates = this.generateDateRange(opt.startTime, opt.endTime)
                row.date = ''
                row.quantity = ''
                row.maxQuantity = opt.maxQuantity || 0
                row.loadingQty = false
                row.qtyHint = `最多可取消 ${opt.maxQuantity || 0} 间`
            }
        },

        onCancelDateChange(val, idx) {
            const row = this.cancelList[idx]
            row.date = val
            row.quantity = ''
            row.loadingQty = true
            row.qtyHint = '查询中...'
            new Api('').seeOrderDetailCancelNumber({
                stockId: row.stockId,
                useDate: val,
                childrenId: this.orderId
            }).then(res => {
                if (res.status === 200 && res.data) {
                    let maxQty = 0
                    if (typeof res.data.productNumber === 'number') {
                        maxQty = res.data.productNumber - (res.data.cancelNumber || 0)
                    } else if (typeof res.data.productNumber === 'object') {
                        maxQty = res.data.productNumber.number - (res.data.productNumber.cancelNumber || 0)
                    }
                    maxQty = Math.max(0, maxQty || 0)
                    row.maxQuantity = maxQty
                    row.qtyHint = `可取消 ${maxQty} 间`
                } else {
                    row.qtyHint = '查询失败'
                }
            }).catch(() => {
                row.qtyHint = '查询异常'
            }).finally(() => {
                row.loadingQty = false
            })
        },

        getOccupiedQty(excludeIdx, roomId, date) {
            let occupied = 0
            for (let i = 0; i < this.cancelList.length; i++) {
                if (i === excludeIdx) continue
                const row = this.cancelList[i]
                if (row.roomId === roomId && row.date === date) {
                    occupied += (Number(row.quantity) || 0)
                }
            }
            return occupied
        },

        getCancelQtyHint(idx) {
            const item = this.cancelList[idx]
            if (!item.roomId || !item.date) return ''
            const maxQty = item.maxQuantity || 0
            if (maxQty <= 0) return '无可取消数量'
            const occupied = this.getOccupiedQty(idx, item.roomId, item.date)
            const remaining = maxQty - occupied
            if (remaining <= 0) return '剩余 0 间'
            return `剩余可取消 ${remaining} 间`
        },

        onCancelQtyInput(idx) {
            this.$nextTick(() => {
                let val = this.cancelList[idx].quantity
                val = parseInt(val) || 0
                if (val < 0) val = 0
                const item = this.cancelList[idx]
                const maxQty = item.maxQuantity || 0
                const occupied = this.getOccupiedQty(idx, item.roomId, item.date)
                const remaining = maxQty - occupied
                if (remaining > 0 && val > remaining) {
                    val = remaining
                    this.$message.warning(`${item.roomLabel || '该题型'}剩余可取消 ${remaining} 间`)
                } else if (remaining <= 0 && val > 0) {
                    val = 0
                    this.$message.warning(`${item.roomLabel || '该题型'}可取消数量已达上限`)
                }
                this.$set(this.cancelList, idx, { ...item, quantity: val })
            })
        },

        confirmCancel() {
            for (let i = 0; i < this.cancelList.length; i++) {
                const item = this.cancelList[i]
                if (!item.roomId) {
                    return this.$message.warning(`第${i + 1}行请选择房型`)
                }
                if (!item.date) {
                    return this.$message.warning(`第${i + 1}行请选择日期`)
                }
                if (!item.quantity || Number(item.quantity) <= 0) {
                    return this.$message.warning(`第${i + 1}行请输入取消数量`)
                }
            }

            // 跨行聚合校验
            const groupMap = {}
            for (let i = 0; i < this.cancelList.length; i++) {
                const item = this.cancelList[i]
                const key = `${item.roomId}_${item.date}`
                if (!groupMap[key]) {
                    groupMap[key] = { label: item.roomLabel, total: 0, max: item.maxQuantity }
                }
                groupMap[key].total += Number(item.quantity) || 0
            }

            for (const key in groupMap) {
                const g = groupMap[key]
                if (g.total > g.max) {
                    return this.$message.warning(`${g.label || '该题型'}取消总量 ${g.total} 超过上限 ${g.max}`)
                }
            }

            this.$confirm('确定要提交减少数量申请吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submitCancel()
            }).catch(() => {})
        },

        async submitCancel() {
            const loading = this.$loading({ lock: true, text: '提交中...' })
            try {
                const cancelItems = this.cancelList.map(item => ({
                    orderChildrenId: this.orderId,
                    useDate: item.date.replace(/-/g, '.'),
                    stockId: item.stockId,
                    cancelNumber: Number(item.quantity),
                    childrenDetailId: item.childrenDetailId
                }))
                const res = await new Api('').orderPartHasBeenPaidAndCancelled(this.orderId, cancelItems)
                loading.close()
                if (res.status === 200) {
                    this.$message.success('已提交取消申请')
                    this.drawerVisible = false
                    this.$emit('success')
                } else {
                    this.$message.error(res.statusText || '提交失败')
                }
            } catch (err) {
                loading.close()
                console.error('提交取消失败', err)
                this.$message.error((err && err.statusText) || '提交失败')
            }
        },

        // ========== 增订项操作 ==========
        addAddItem() {
            this.addList.push({ roomLabel: '', roomId: '', date: '', quantity: '' })
        },

        removeAddItem(idx) {
            this.addList.splice(idx, 1)
        },

        onAddRoomChange(val, idx) {
            const opt = this.inquiryRoomOptions.find(o => o.value === val)
            if (opt) {
                this.addList[idx].roomId = opt.value
                this.addList[idx].roomLabel = opt.label
                this.addList[idx].maxQuantity = opt.maxQuantity || 0
            }
        },

        onAddDateChange(val, idx) {
            const today = this.formatDate(new Date())
            if (val < today) {
                this.$message.warning('询价日期无效，请选择今天或未来的日期')
                this.addList[idx].date = ''
                return
            }
            this.addList[idx].date = val
        },

        formatDate(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },

        onAddQtyInput(idx) {
            let val = this.addList[idx].quantity
            val = parseInt(val) || 0
            if (val < 0) val = 0
            const maxQty = this.addList[idx].maxQuantity || 0
            if (maxQty > 0 && val > maxQty) {
                this.$message.warning(`订单中原有 ${maxQty} 间，请注意核对`)
            }
            this.addList[idx].quantity = val
        },

        confirmInquiry() {
            for (let i = 0; i < this.addList.length; i++) {
                const item = this.addList[i]
                if (!item.roomId) {
                    return this.$message.warning(`第${i + 1}行请选择房型`)
                }
                if (!item.date) {
                    return this.$message.warning(`第${i + 1}行请选择日期`)
                }
                if (!item.quantity || Number(item.quantity) <= 0) {
                    return this.$message.warning(`第${i + 1}行请输入数量`)
                }
            }

            this.$confirm('确定要提交询价吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submitInquiry()
            }).catch(() => {})
        },

        async submitInquiry() {
            const loading = this.$loading({ lock: true, text: '提交中...' })
            try {
                const hotelRoomList = this.addList.map(item => ({
                    hotelRoomName: item.roomLabel || '',
                    hotelRoomNameEn: null,
                    roomBudget: null,
                    roomNumber: Number(item.quantity) || 0,
                    roomDate: item.date
                }))

                const params = {
                    cityId: this.orderInfo.linkId,
                    cityName: this.orderInfo.linkName || this.orderInfo.linkNameEn,
                    orderNumber: this.orderInfo.orderChildrenId,
                    stockId: this.orderDetailList[0]?.stockId,
                    hotelRoomList,
                    remarks: this.orderInfo.resourceName || this.orderInfo.resourceNameEn
                }

                const result = await new Api('').orderInquiryAdd1(params)
                loading.close()
                if (result.status === 200) {
                    this.$message.success('询价已发送')
                    this.drawerVisible = false
                    this.$emit('success')
                } else {
                    this.$message.error('提交失败')
                }
            } catch (err) {
                loading.close()
                this.$message.error('提交失败')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    min-height: 100%;
    background: #F5F6FA;
    padding: 12px 16px 24px;
}

/* Tab 切换 */
.tab-bar {
    display: flex;
    background: #fff;
    border-radius: 8px;
    padding: 4px;
    margin-bottom: 16px;

    .tab-item {
        flex: 1;
        text-align: center;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        color: #666;
        border-radius: 6px;
        cursor: pointer;
        transition: all .2s;

        &.active {
            background: #DE562C;
            color: #fff !important;
            font-weight: 600;
        }

        &:hover:not(.active) {
            background: #f5f5f5;
        }
    }
}

.card {
    background: #fff;
    border-radius: 10px;
    padding: 18px;
    margin-bottom: 16px;
}

.section-title {
    font-size: 14px;
    font-weight: 600;
    color: #8e99a8;
    padding-bottom: 14px;
}

/* 编辑行：房型 | 日期 | 数量 | 删除 */
.edit-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;

    .qty-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        position: relative;
    }

    .qty-hint {
        font-size: 11px;
        color: #10B981;
        white-space: nowrap;
        margin-top: 2px;

        &.loading {
            color: #F59E0B;
        }
    }

    .delete-btn {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;
        color: #E74C3C;
        font-size: 16px;
        border-radius: 50%;
        transition: background .2s;

        &:hover {
            background: #FDECEA;
        }
    }
}

/* 添加按钮 */
.add-item-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    border: 2px dashed #CCC;
    border-radius: 6px;
    font-size: 13px;
    color: #555;
    margin-bottom: 20px;
    cursor: pointer;
    transition: background .2s;

    &:hover {
        background: #F8F8F8;
    }

    i {
        margin-right: 4px;
    }
}

/* 提交按钮 */
.submit-row {
    margin-top: 8px;
    text-align: center;

    .submit-btn {
        min-width: 140px;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        font-weight: 600;
    }

    .btn-red {
        background-color: #E74C3C;
        border-color: #E74C3C;

        &:hover {
            opacity: .85;
        }
    }

    .btn-dark {
        background-color: #222;
        border-color: #222;

        &:hover {
            opacity: .85;
        }
    }
}
</style>
